import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32.6665 0H0.666504V32H32.6665V0Z",
      class: "bg",
      fill: "#DAF6FF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M25.9998 5.33301H7.33315C6.59677 5.33301 5.99982 5.92996 5.99982 6.66634V14.6663C5.99982 15.4027 6.59677 15.9997 7.33315 15.9997H25.9998C26.7362 15.9997 27.3331 15.4027 27.3331 14.6663V6.66634C27.3331 5.92996 26.7362 5.33301 25.9998 5.33301Z",
      class: "primary",
      fill: "#00BBF9"
    }, null, -1),
    _createElementVNode("path", {
      d: "M25.9998 22.667H7.33315C6.59677 22.667 5.99982 23.2639 5.99982 24.0003V25.3337C5.99982 26.07 6.59677 26.667 7.33315 26.667H25.9998C26.7362 26.667 27.3331 26.07 27.3331 25.3337V24.0003C27.3331 23.2639 26.7362 22.667 25.9998 22.667Z",
      class: "secondary",
      fill: "#80DDFC"
    }, null, -1),
    _createElementVNode("path", {
      d: "M25.9998 17.333H7.33315C6.59677 17.333 5.99982 17.93 5.99982 18.6663V19.9997C5.99982 20.7361 6.59677 21.333 7.33315 21.333H25.9998C26.7362 21.333 27.3331 20.7361 27.3331 19.9997V18.6663C27.3331 17.93 26.7362 17.333 25.9998 17.333Z",
      class: "secondary",
      fill: "#80DDFC"
    }, null, -1)
  ])))
}
export default { render: render }